import { PageWrapper } from "@/components";
import { CategoryTypeHeaderItem } from "@/components/DynamicForm/styled";
import DashboardCustomizeMenu from "@/containers/Dashboard/components/DashboardCustomizeMenu";
import {
  getDashboardWidgetStorageKey,
  useDashboardWidgetPreferences,
} from "@/containers/Dashboard/hooks/useDashboardWidgetPreferences";
import { CONTENT_WIDTH as GRID_SIZES, GUTTER_SIZE } from "@/enums";
import { routes } from "@/helpers";
import { useAllRights } from "@/hooks";
import { useUserContext } from "@/providers/UserProvider";
import { faCirclePlus, faSliders } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Empty, Row, Space, Tooltip } from "antd";
import { useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

const DashboardContent = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const rights = useAllRights();
  const [customizeOpen, setCustomizeOpen] = useState(false);
  const { widgets, visibleWidgets, setOrder, setVisible, reset } =
    useDashboardWidgetPreferences();

  return (
    <PageWrapper
      pageTitle={intl.formatMessage({ id: "home.dashboard.title" })}
      noBackButton
    >
      <Row gutter={GUTTER_SIZE.large} justify="space-between" align="top">
        <Col>
          <CategoryTypeHeaderItem>
            {intl.formatMessage({
              id: "dashboard.titles.myDashboard",
            })}
          </CategoryTypeHeaderItem>
        </Col>
        <Col xxs={GRID_SIZES.half}>
          <Space>
            <Tooltip
              title={intl.formatMessage({ id: "dashboard.customize.button" })}
            >
              <span>
                <DashboardCustomizeMenu
                  open={customizeOpen}
                  onOpenChange={setCustomizeOpen}
                  widgets={widgets}
                  setOrder={setOrder}
                  setVisible={setVisible}
                  reset={reset}
                >
                  <Button
                    data-test-id="dashboard-customize-button"
                    icon={<FontAwesomeIcon icon={faSliders} />}
                    aria-label={intl.formatMessage({
                      id: "dashboard.customize.button",
                    })}
                  />
                </DashboardCustomizeMenu>
              </span>
            </Tooltip>
            {rights.canCreateIntake && (
              <Button
                data-test-id="project-list-add-intake"
                type="primary"
                onClick={() => navigate(routes.projects.new)}
                icon={<FontAwesomeIcon icon={faCirclePlus} />}
              >
                {intl.formatMessage({ id: "projectIntake.create" })}
              </Button>
            )}
          </Space>
        </Col>
      </Row>
      {visibleWidgets.length ? (
        <Row gutter={GUTTER_SIZE.small}>
          {visibleWidgets.map(({ id, Component }) => (
            <Component key={id} />
          ))}
        </Row>
      ) : (
        <Empty
          description={intl.formatMessage({
            id: "dashboard.customize.allHidden",
          })}
        >
          <Button
            type="primary"
            data-test-id="dashboard-customize-empty-button"
            onClick={() => setCustomizeOpen(true)}
          >
            {intl.formatMessage({ id: "dashboard.customize.openCustomize" })}
          </Button>
        </Empty>
      )}
    </PageWrapper>
  );
};

const Dashboard = () => {
  const { userToken } = useUserContext();
  const storageKey = getDashboardWidgetStorageKey(userToken?.user?.id);

  return <DashboardContent key={storageKey} />;
};

export default Dashboard;
